// Suppress unhandled promise rejections caused by network failures.
// Safari throws "TypeError: Load failed", Chrome throws "TypeError: Failed to fetch",
// and Firefox throws "TypeError: NetworkError..." when fetch calls fail due to
// lost connectivity (e.g., browser sleep/wake cycles, intermittent network).
// Turbo throws "AbortError: Fetch is aborted" (a DOMException) when navigating
// away while requests are still in-flight.
// These are not actionable bugs and create noise in error reporting.
const NETWORK_ERROR_PATTERN = /Load failed|Failed to fetch|NetworkError/

window.addEventListener("unhandledrejection", event => {
  const error = event.reason
  if (error instanceof TypeError && NETWORK_ERROR_PATTERN.test(error.message)) {
    event.preventDefault()
  }
  if (error instanceof DOMException && error.name === "AbortError") {
    event.preventDefault()
  }
})
